import { FC, ReactElement } from 'react';

import { ConnectedDevelopmentHeader, ConnectedDevelopmentOverview } from '../../../../../connectors';

import './Development.scss';

const Development: FC = (): ReactElement => (
    <>
        <ConnectedDevelopmentHeader className="development-tab__card" />
        <ConnectedDevelopmentOverview className="development-tab__card" />
    </>
);

export default Development;
